import React, { useEffect, useState, useCallback } from "react";
import Swal from "sweetalert2";
import { HelpHttp } from "helpers/HelpHttp";
import { HelpFunctions } from "helpers/HelpFunctions";
import { trackPromise } from "react-promise-tracker";
import axios from "axios";

const { REACT_APP_API } = process.env;

const ConsultEventsStatusService = ({ service }) => {
    const [parameters, setParameters] = useState([]);
    const [success, setSuccess] = useState("");
    const [timeout, setTimeout] = useState("");
    const [codError, setCodError] = useState("");
    const [trama, setTrama] = useState({});

    let api = HelpHttp();
    let f = HelpFunctions();

    const urlTrama = `${REACT_APP_API}/parameters/findTrama`;
    const url = `${REACT_APP_API}/parameters/findAllByService/${service.code}`;

    const getParameters = async () => {
        trackPromise(
            api.get(url).then((res) => {
                if (res.err) {
                    setParameters(null);
                } else {
                    setParameters(res);
                    res.forEach((element) => {
                        if (element.parameter === "success") {
                            setSuccess(element.value);
                            setCodError(element.cod_error);
                        } else if (element.parameter === "timeout") {
                            setTimeout(element.value);
                        }
                    });
                }
            })
        );
    };

    async function updateParameters() {
        let data1 = {};
        let data2 = {};
        let error = false;

        if (!parameters.length) {
            Swal.fire({ icon: "error", title: "Oops...", text: "No hay parámetros disponibles." });
            return null;
        }

        parameters.forEach((param) => {
            if (param.parameter === "success") {
                data1.service = service.code;
                data1.parameter = "success";
                data1.value = success;
                if (!success) {
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "El valor de success no puede estar vacío.",
                    });
                    error = true;
                } else if (success === "false" && (!codError || codError === '200')) {
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Por favor, seleccione un tipo de error!",
                    });
                    error = true;
                } else if (success === "true" && (!codError || codError !== 'S1' && codError !== 'S2' && codError !== 'S3' && codError !== 'S4' && codError !== 'S5' && codError !== 'S6' && codError !== 'S7')) {
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Por favor, seleccione un tipo de éxito!",
                    });
                    error = true;
                } else {
                    data1.cod_error = codError;
                }
            } else if (param.parameter === "timeout") {
                data2.service = service.code;
                data2.parameter = "timeout";
                data2.value = timeout;

                if (!timeout) {
                    Swal.fire({ icon: "error", title: "Oops...", text: "El valor de timeout no puede estar vacío." });
                    error = true;
                }
            }
        });

        if (error) return null;

        try {
            const resp1 = await f.updateParam(data1);
            if (resp1.success) {
                const resp2 = await f.updateParam(data2);
                if (resp2.success) {
                    Swal.fire("Ok", "¡Datos actualizados!", "success");
                    await getParameters();
                } else {
                    Swal.fire("¡Ok!", `${resp2.message}!`, "warning");
                }
            } else {
                Swal.fire("Ok", `${resp1.message}!`, "warning");
            }
        } catch (err) {
            console.error(err);
            Swal.fire({ icon: "error", title: "Error", text: "Ocurrió un error al actualizar los parámetros." });
        }
    }

    const getTrama = useCallback(async (url) => {
        let { data } = await axios.post(url, parameters);
        setTrama(data);
    }, [parameters]);

    useEffect(() => {
        getParameters();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!parameters.length) return;
        const paramSuccess = parameters.find((p) => p.parameter === "success");
        if (paramSuccess) setCodError(paramSuccess.cod_error);
        getTrama(urlTrama);
    }, [parameters, getTrama, urlTrama]);

    return (
        <>
            {parameters && (
                <div className="card">
                    <h5 className="card-header">
                        {service.name}{" "}
                        <small style={{ fontWeight: "normal" }} className="text-muted">
                            {service.endpoint || "Sin Ruta"}
                        </small>
                    </h5>
                    <div className="card-body">
                        <p className="card-text">{service.description}</p>

                        {/* --- Parámetro Success --- */}
                        <fieldset className="row mb-3">
                            <legend className="col-form-label col-sm-3 pt-0">Parámetro Success:</legend>
                            <div className="col-sm-9">
                                <div className="form-check">
                                    <div className="row">
                                        <div className="col-sm-2">
                                            <input type="radio" className="form-check-input" id="geoValRad_success_true"
                                                checked={success === "true"} name="geoValRadioSuccess" value="true"
                                                onChange={(e) => { setSuccess(e.target.value); setCodError(""); }} />
                                            <label htmlFor="geoValRad_success_true" className="form-check-label">True</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-check">
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <input type="radio" className="form-check-input" id="geoValRad_success_false"
                                                checked={success === "false"} name="geoValRadioSuccess" value="false"
                                                onChange={(e) => { setSuccess(e.target.value); setCodError(""); }} />
                                            <label htmlFor="geoValRad_success_false" className="form-check-label">False</label>
                                        </div>

                                        {success === "true" && (
                                            <div className="col-sm-6">
                                                <div className="mb-2">
                                                    <label htmlFor="geoValCodSuccess">Tipo de Éxito</label>
                                                    <select className="form-select form-select-sm"
                                                        onChange={(e) => setCodError(e.target.value)}
                                                        name="geoValCodError" id="geoValCodSuccess" value={codError}>
                                                        <option value="">Seleccione...</option>
                                                        <option value="S1">(status 200) - status Activado (A)</option>
                                                        <option value="S2">(status 200) - status Proccess (P)</option>
                                                        <option value="S3">(status 200) - status Rechazado (R)</option>
                                                    </select>
                                                </div>
                                            </div>
                                        )}

                                        {success === "false" && (
                                            <div className="col-sm-6">
                                                <div className="mb-2">
                                                    <label htmlFor="geoValCodError">Tipo de Error</label>
                                                    <select className="form-select form-select-sm"
                                                        onChange={(e) => setCodError(e.target.value)}
                                                        name="geoValCodError" id="geoValCodError" value={codError}>
                                                        <option value="">Seleccione...</option>
                                                        <option value="E1">(status 400) - Error Parametros Incorrectos</option>
                                                        <option value="E2">(status 500) - Error Interno </option>
                                                        <option value="E3">(status 503) - Error Legados No disponibles </option>
                                                    </select>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </fieldset>

                        {/* --- Parámetro Timeout --- */}
                        <fieldset className="row mb-3">
                            <legend className="col-form-label col-sm-3 pt-0">Parámetro Timeout:</legend>
                            <div className="col-sm-9">
                                <div className="form-check">
                                    <input type="radio" className="form-check-input" id="geoValRad_timeout_true"
                                        checked={timeout === "true"} name="geoValRadioTimeout" value="true"
                                        onChange={(e) => setTimeout(e.target.value)} />
                                    <label htmlFor="geoValRad_timeout_true">True</label>
                                    <br />
                                </div>
                                <div className="form-check">
                                    <input type="radio" className="form-check-input" id="geoValRad_timeout_false"
                                        checked={timeout === "false"} name="geoValRadioTimeout" value="false"
                                        onChange={(e) => setTimeout(e.target.value)} />
                                    <label htmlFor="geoValRad_timeout_false">False</label>
                                    <br />
                                </div>
                            </div>
                        </fieldset>

                        <button type="submit" className="btn btn-primary" onClick={updateParameters}>
                            <i className="bi bi-save2" /> Actualizar
                        </button>
                    </div>

                    {/* --- Trama Request --- */}
                    <div className="card bg-light mt-2">
                        <div className="card-body">
                            <h6>Request:</h6>
                            <pre><code>{JSON.stringify(trama.request, null, 2)}</code></pre>
                        </div>
                    </div>

                    {/* --- Trama Response --- */}
                    <div className="card bg-light mt-2">
                        <div className="card-body">
                            <h6>Response:</h6>
                            <pre><code>{JSON.stringify(trama.content, null, 2)}</code></pre>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ConsultEventsStatusService;

